import { createApp } from 'vue'

import App from './App.vue'
import router from './router';
import '@/assets/scss/app.scss'
import VueFeather from 'vue-feather';
import store from './store'
import Breadcrumbs from './components/bread_crumbs';
import "bootstrap"
import 'bootstrap/dist/js/bootstrap.bundle'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueAnimateOnScroll from 'vue3-animate-onscroll';
import Lightbox from 'vue-easy-lightbox'
import vue3StarRatings from "vue3-star-ratings";
import Datepicker from 'vue3-datepicker'
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import VueApexCharts from "vue3-apexcharts";
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import 'jspreadsheet-ce/dist/jspreadsheet.css'
import 'jsuites/dist/jsuites.css'

import { defaultLocale, localeOptions } from './constants/config';
import { limitMobileInput, MOBILE_MAX_LENGTH } from './utils/mobileInput';
import { extractApiMessage, getApiErrorMessage, applyApiFieldErrors, wrapSwal } from './utils/apiMessage';
import { canRevoke, canUpdateRenewalData } from './utils/auth';

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import { ref, onMounted } from 'vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'


const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = createI18n({

   locale: locale,
   messages: {
      English: English,


   }
});

const app = createApp(App).use(VueAxios, axios).use(i18n).use(SimpleTypeahead).component("vue3-star-ratings", vue3StarRatings).use(Lightbox).use(store).use(VueSweetalert2, {
   position: "top-end",
   showConfirmButton: false,
   timer: 3500,
   toast: true,
})
   .use(VueGoogleMaps, {
      load: {
         key: '',
         libraries: "places",
         // version: "3.53"
         v: "weekly"
      },
   })
   .use(VueAnimateOnScroll).use(router).use(PerfectScrollbar).component(VueFeather.name, VueFeather).component("apexchart", VueApexCharts).component('Breadcrumbs', Breadcrumbs).use(require('vue-chartist')).component('Datepicker', Datepicker)

// Ensure nested API validation objects (e.g. { payment_id: ["…"] }) show in toasts
app.config.globalProperties.$swal = wrapSwal(app.config.globalProperties.$swal);
app.config.globalProperties.$extractApiMessage = extractApiMessage;
app.config.globalProperties.$getApiErrorMessage = getApiErrorMessage;
app.config.globalProperties.$applyApiFieldErrors = applyApiFieldErrors;
app.config.globalProperties.$canRevoke = canRevoke;
app.config.globalProperties.$canUpdateRenewalData = canUpdateRenewalData;

const axiosInstance = axios.create({
   // baseURL: 'http://127.0.0.1:8000/'
   // baseURL: 'https://dev-api.airotrack.in/airotrack-api/public/'
   baseURL: 'https://api.airotrack.in/'
});

axiosInstance.interceptors.response.use(
   (response) => response,
   (error) => {
      if (error.response && error.response.status === 401) {
         localStorage.removeItem('airotrack_staff');
         router.push({ name: 'Login' });
      }
      return Promise.reject(error);
   }
);

app.config.globalProperties.$axios = axiosInstance;
// app.config.globalProperties.$image_url = 'http://127.0.0.1:8000/storage/';
// app.config.globalProperties.$image_url = 'https://dev-api.airotrack.in/airotrack-api/public/storage/';
app.config.globalProperties.$image_url = 'https://api.airotrack.in/storage/';


app.config.globalProperties.$filters = {
   formatDateTime(datetime) {
      return moment.utc(datetime).format('DD MMM YYYY, hh:mm a');
   },
   formatDate(date) {
      return moment.utc(date).format('DD MMM YYYY');
   }
}

// Prevent scroll wheel from incrementing/decrementing number inputs
document.addEventListener(
   'wheel',
   (e) => {
      const el = e.target;
      if (el instanceof HTMLInputElement && el.type === 'number') {
         e.preventDefault();
      }
   },
   { passive: false }
);

app.directive('mobile-limit', {
   mounted(el, binding) {
      const maxLength = Number(binding.value) || MOBILE_MAX_LENGTH;
      el.type = 'text';
      el.inputMode = 'numeric';
      el.maxLength = maxLength;

      const cleanValue = () => {
         const cleaned = limitMobileInput(el.value, maxLength);
         if (el.value !== cleaned) {
            el.value = cleaned;
            el.dispatchEvent(new Event('input', { bubbles: true }));
         }
      };

      cleanValue();
      el.addEventListener('input', cleanValue);
      el._mobileLimitCleanup = () => el.removeEventListener('input', cleanValue);
      el._mobileLimitCleanValue = cleanValue;
   },
   updated(el) {
      el._mobileLimitCleanValue?.();
   },
   unmounted(el) {
      el._mobileLimitCleanup?.();
   },
});

app.mount('#app')



